import { Component } from '@angular/core';
import { ACDATAConnectorPanel } from '../a.cdata.connector.panel';
import { CDATAConnectorInfo } from '../../../../../../../models/datamodel/adbinfo.model';

@Component({
    selector: 'db2-connector-panel',
    templateUrl: './db2.connector.panel.html'
})
export class DB2ConnectorPanel extends ACDATAConnectorPanel {
    static GetInfo(): CDATAConnectorInfo {
        return {
            Caption: '@@DB2',
            Type: 'evidanza.Database.CData.CDataConnector.ConnectorsInfo.DB2Info',
            ControlType: DB2ConnectorPanel,
            Default: {
                AuthScheme: 0
            }
        };
    }
}